import { TransferDndProvider } from "@/dnd/TransferDndProvider";
import React from "react";

/**
 * Mounts the app-wide `<DndContext>` (via `TransferDndProvider`) for
 * cross-surface file moves (files rail, canvas explorer, entity picker,
 * workspace detail, chat composer).
 */
export function CanvasDndConditional({
  enabled,
  children,
}: {
  enabled: boolean;
  children: React.ReactNode;
}) {
  if (!enabled) return <>{children}</>;
  return <TransferDndProvider>{children}</TransferDndProvider>;
}
